import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import "../../CSS/ComponentCSS/BarChart.css";
import { randomColor, randomColorValue } from "../Charts/ColorList";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

type BarChartsProps = {
  columnlabel: any[];
  data: any[];
  label: any[]; //배열 내부 배열리스트
};

export default function BarCharts(props: BarChartsProps) {
  const [data, setData] = useState<any>({ label: [], datasets: [] });
  const color = randomColorValue();
  const [randomColors, setRandomColors] = useState<any[]>([]);

  useEffect(() => {
    if (randomColors.length == 0 && props.columnlabel.length > 0) {
      setRandomColors(props.columnlabel.map(() => randomColor(color)));
    }
    if (props.columnlabel.length != 0 && randomColors.length > 0) {
      setData({
        labels: props.columnlabel,
        datasets: props.data.map((item: any, index: any) => {
          return {
            label: props.label[index],
            backgroundColor: randomColors,
            barPercentage: 0.8,
            data: item,
            datalabels: {
              align: "end",
              anchor: "end",
            },
          };
        }),
      });
    }
  }, [props.data, randomColors]);

  const options: ChartOptions<"bar"> = {
    responsive: true, //반응형
    scales: {
      x: {
        grid: {
          drawOnChartArea: false, // x축 그리드 선 제거
        },
      },
      y: {
        grid: {
          drawOnChartArea: true, // y축 그리드 선 제거
        },
        beginAtZero: true,
        afterDataLimits: (scale) => {
          scale.max = scale.max * 1.1;
        },
        title: {
          display: true,
          align: "end",
          color: "#808080",
          text: "단위: 명",
        },
      },
    },
    indexAxis: "x", //차트 방향
    plugins: {
      datalabels: {
        formatter: function (value, context) {
          return value + "명";
        },
        color: "black",
      },
      legend: {
        display: true, //범례 안 보이게 하기
        labels: {
          usePointStyle: true,
          padding: 10,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            let label = context.dataset.label + "" || "";

            return context.parsed.y !== null
              ? label + ": " + context.parsed.y + "명"
              : label + ": 0명";
          },
        },
      },
      title: {
        display: false, //타이틀 안 보이게 하기
      },
    },
  };

  return (
    <div className="BarChartContainer">
      <Bar options={options} data={data} />
    </div>
  );
}
